module.exports = __webpack_public_path__ + "img/ic_hub_connect_line_right.dee95e50.svg";